import { render, staticRenderFns } from "./ReflectEdit.vue?vue&type=template&id=5622ee4c&scoped=true"
import script from "./ReflectEdit.vue?vue&type=script&lang=js"
export * from "./ReflectEdit.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622ee4c",
  null
  
)

export default component.exports